export class ClaimTypes {
    private static ClaimType2005Namespace = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims';
    private static ClaimType2008Namespace = 'http://schemas.microsoft.com/ws/2008/06/identity/claims';

    public static Name: string = this.ClaimType2005Namespace + '/name';
    public static NameIdentifier: string = this.ClaimType2005Namespace + '/nameidentifier';
    public static Email: string = this.ClaimType2005Namespace + '/emailaddress';

    public static Role: string = this.ClaimType2008Namespace + '/role';
    public static FId: string = 'Vestra/claims/UserId';
}

export class RoleNames {
    public static Admin: string = 'Admin';
    public static Partner: string = 'Partner';
    public static VestraUser: string = 'VestraUser';
}
